import posthog from "posthog-js";
import { systemProductEvents } from "./dashboard-product-events";
import { isMixpanelInitialized, registerMixpanelUser, trackMixpanelEvent, } from "./mixpanel-analytics";
let posthogInitialized = false;
function trimStr(v) {
    return typeof v === "string" ? v.trim() : "";
}
/**
 * Label shown as the person "Name" in PostHog / Mixpanel from DB-backed profile fields.
 * Falls back to email when name parts are empty (avoids displaying raw distinct ids).
 */
function buildPersonDisplayNameForAnalytics(params) {
    const first = trimStr(params.properties?.firstName);
    const middle = trimStr(params.properties?.middleName);
    const last = trimStr(params.properties?.lastName);
    const combined = [first, middle, last].filter(Boolean).join(" ");
    if (combined)
        return combined;
    const email = trimStr(params.email);
    if (email)
        return email;
    return "";
}
export function initClientSideProductAnalytics({ apiKey, uiHost = "https://eu.posthog.com", apiHost = "https://eu.i.posthog.com", captureExceptions = false, // we use Highlight for APM
debug, }) {
    if (!apiKey) {
        console.warn("POSTHOG_API_KEY is required, analytics will not be initialised");
        return;
    }
    posthogInitialized = true;
    posthog.init(apiKey, {
        api_host: apiHost,
        ui_host: uiHost,
        defaults: "2025-05-24",
        capture_exceptions: captureExceptions, // This enables capturing exceptions using Error Tracking, set to false if you don't want this
        debug,
        person_profiles: "always",
    });
}
/** Identifies the user in PostHog (if inited) and Mixpanel (if inited). Both may run; neither removes the other. */
export function registerUserForTracking({ userId, email, properties, }) {
    const displayName = buildPersonDisplayNameForAnalytics({ email, properties });
    const personProps = { ...(properties ?? {}) };
    if (displayName) {
        personProps.name = displayName;
    }
    if (posthogInitialized) {
        posthog.identify(userId, {
            email,
            ...personProps,
        });
        console.log("[analytics] User identified (PostHog)", userId, {
            email,
            ...personProps,
        });
    }
    if (isMixpanelInitialized()) {
        const mpPerson = { ...(properties ?? {}) };
        if (displayName) {
            mpPerson.$name = displayName;
        }
        const first = trimStr(properties?.firstName);
        const last = trimStr(properties?.lastName);
        if (first)
            mpPerson.$first_name = first;
        if (last)
            mpPerson.$last_name = last;
        registerMixpanelUser({
            distinctId: userId,
            email,
            properties: mpPerson,
        });
    }
    if (posthogInitialized || isMixpanelInitialized()) {
        trackEvent({
            event: systemProductEvents.userIdentified,
            properties: {
                userId,
                email,
                ...(displayName ? { name: displayName } : {}),
                ...(properties ?? {}),
            },
            userId,
        });
    }
}
/** Sends the same custom event to PostHog and/or Mixpanel when each SDK is initialised. */
export function trackEvent({ event, properties, userId, }) {
    if (posthogInitialized) {
        posthog.capture(event, {
            ...(properties ?? {}),
            userId: userId ?? posthog.get_distinct_id(),
        });
    }
    if (isMixpanelInitialized()) {
        const mpProps = { ...(properties ?? {}) };
        if (userId !== undefined)
            mpProps.userId = userId;
        trackMixpanelEvent(event, mpProps);
    }
}
